export const backupCodesEndpointPath = '/api/v2/backup-codes'
export const backupCodesVerifyEndpointPath = '/api/v2/backup-codes/verify'
